/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "i går",
        "-2": "i forgårs",
        "0": "i dag",
        "1": "i morgen",
        "2": "i overmorgen",
        "future": {
          "one": "om {0} døgn",
          "other": "om {0} døgn"
        },
        "past": {
          "one": "for {0} døgn siden",
          "other": "for {0} døgn siden"
        }
      },
      "day-narrow": {
        "-1": "i går",
        "-2": "-2 d.",
        "0": "i dag",
        "1": "i morgen",
        "2": "+2 d.",
        "future": {
          "one": "+{0} d.",
          "other": "+{0} d."
        },
        "past": {
          "one": "-{0} d.",
          "other": "-{0} d."
        }
      },
      "day-short": {
        "-1": "i går",
        "-2": "i forgårs",
        "0": "i dag",
        "1": "i morgen",
        "2": "i overmorgen",
        "future": {
          "one": "om {0} d.",
          "other": "om {0} d."
        },
        "past": {
          "one": "for {0} d. siden",
          "other": "for {0} d. siden"
        }
      },
      "hour": {
        "0": "denne timen",
        "future": {
          "one": "om {0} time",
          "other": "om {0} timer"
        },
        "past": {
          "one": "for {0} time siden",
          "other": "for {0} timer siden"
        }
      },
      "hour-narrow": {
        "0": "denne timen",
        "future": {
          "one": "+{0} t",
          "other": "+{0} t"
        },
        "past": {
          "one": "-{0} t",
          "other": "-{0} t"
        }
      },
      "hour-short": {
        "0": "denne timen",
        "future": {
          "one": "om {0} t",
          "other": "om {0} t"
        },
        "past": {
          "one": "for {0} t siden",
          "other": "for {0} t siden"
        }
      },
      "minute": {
        "0": "dette minuttet",
        "future": {
          "one": "om {0} minutt",
          "other": "om {0} minutter"
        },
        "past": {
          "one": "for {0} minutt siden",
          "other": "for {0} minutter siden"
        }
      },
      "minute-narrow": {
        "0": "dette minuttet",
        "future": {
          "one": "+{0} min",
          "other": "+{0} min"
        },
        "past": {
          "one": "-{0} min",
          "other": "-{0} min"
        }
      },
      "minute-short": {
        "0": "dette minuttet",
        "future": {
          "one": "om {0} min",
          "other": "om {0} min"
        },
        "past": {
          "one": "for {0} min siden",
          "other": "for {0} min siden"
        }
      },
      "month": {
        "-1": "forrige måned",
        "0": "denne måneden",
        "1": "neste måned",
        "future": {
          "one": "om {0} måned",
          "other": "om {0} måneder"
        },
        "past": {
          "one": "for {0} måned siden",
          "other": "for {0} måneder siden"
        }
      },
      "month-narrow": {
        "-1": "forrige md.",
        "0": "denne md.",
        "1": "neste md.",
        "future": {
          "one": "+{0} md.",
          "other": "+{0} md."
        },
        "past": {
          "one": "-{0} md.",
          "other": "-{0} md."
        }
      },
      "month-short": {
        "-1": "forrige md.",
        "0": "denne md.",
        "1": "neste md.",
        "future": {
          "one": "om {0} md.",
          "other": "om {0} md."
        },
        "past": {
          "one": "for {0} md. siden",
          "other": "for {0} md. siden"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "forrige kvartal",
        "0": "dette kvartalet",
        "1": "neste kvartal",
        "future": {
          "one": "om {0} kvartal",
          "other": "om {0} kvartaler"
        },
        "past": {
          "one": "for {0} kvartal siden",
          "other": "for {0} kvartaler siden"
        }
      },
      "quarter-narrow": {
        "-1": "forrige kv.",
        "0": "dette kv.",
        "1": "neste kv.",
        "future": {
          "one": "+{0} kv.",
          "other": "+{0} kv."
        },
        "past": {
          "one": "-{0} kv.",
          "other": "-{0} kv."
        }
      },
      "quarter-short": {
        "-1": "forrige kv.",
        "0": "dette kv.",
        "1": "neste kv.",
        "future": {
          "one": "om {0} kv.",
          "other": "om {0} kv."
        },
        "past": {
          "one": "for {0} kv. siden",
          "other": "for {0} kv. siden"
        }
      },
      "second": {
        "0": "nå",
        "future": {
          "one": "om {0} sekund",
          "other": "om {0} sekunder"
        },
        "past": {
          "one": "for {0} sekund siden",
          "other": "for {0} sekunder siden"
        }
      },
      "second-narrow": {
        "0": "nå",
        "future": {
          "one": "+{0} s",
          "other": "+{0} s"
        },
        "past": {
          "one": "-{0} s",
          "other": "-{0} s"
        }
      },
      "second-short": {
        "0": "nå",
        "future": {
          "one": "om {0} sek",
          "other": "om {0} sek"
        },
        "past": {
          "one": "for {0} sek siden",
          "other": "for {0} sek siden"
        }
      },
      "week": {
        "-1": "forrige uke",
        "0": "denne uken",
        "1": "neste uke",
        "future": {
          "one": "om {0} uke",
          "other": "om {0} uker"
        },
        "past": {
          "one": "for {0} uke siden",
          "other": "for {0} uker siden"
        }
      },
      "week-narrow": {
        "-1": "forrige uke",
        "0": "denne uken",
        "1": "neste uke",
        "future": {
          "one": "+{0} u.",
          "other": "+{0} u."
        },
        "past": {
          "one": "-{0} u.",
          "other": "-{0} u."
        }
      },
      "week-short": {
        "-1": "forrige uke",
        "0": "denne uken",
        "1": "neste uke",
        "future": {
          "one": "om {0} u.",
          "other": "om {0} u."
        },
        "past": {
          "one": "for {0} u. siden",
          "other": "for {0} u. siden"
        }
      },
      "year": {
        "-1": "i fjor",
        "0": "i år",
        "1": "neste år",
        "future": {
          "one": "om {0} år",
          "other": "om {0} år"
        },
        "past": {
          "one": "for {0} år siden",
          "other": "for {0} år siden"
        }
      },
      "year-narrow": {
        "-1": "i fjor",
        "0": "i år",
        "1": "neste år",
        "future": {
          "one": "+{0} år",
          "other": "+{0} år"
        },
        "past": {
          "one": "-{0} år",
          "other": "-{0} år"
        }
      },
      "year-short": {
        "-1": "i fjor",
        "0": "i år",
        "1": "neste år",
        "future": {
          "one": "om {0} år",
          "other": "om {0} år"
        },
        "past": {
          "one": "for {0} år siden",
          "other": "for {0} år siden"
        }
      }
    },
    "locale": "nb"
  });
}